import { LNGS_NAMESPACE_RESOURCES } from '@ingenico/util-i18n-config';
import { CoreControllerInput } from '@ingenico/react-ui/core-form';
import type { ReactElement } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './EditResourceForm.module.scss';
import { EditResourceFileField } from '../edit-resource-file-field/EditResourceFileField.ctrl';
import type { EditResourceFormValues } from '../resources-list/ResourcesList.model';

export interface EditResourceFormProps {
  readonly form: UseFormReturn<EditResourceFormValues>;
}

export function EditResourceForm({ form }: EditResourceFormProps): ReactElement {
  const { t } = useTranslation([LNGS_NAMESPACE_RESOURCES.DEFAULT]);

  return (
    <div className={styles.container}>
      <EditResourceFileField control={form.control} />
      <CoreControllerInput
        control={form.control}
        dataTestId="field-edit-resource-name"
        label={t('field.name', { ns: LNGS_NAMESPACE_RESOURCES.DEFAULT })}
        name="name"
        required
      />
      <CoreControllerInput
        control={form.control}
        dataTestId="field-edit-resource-description"
        label={t('field.description', { ns: LNGS_NAMESPACE_RESOURCES.DEFAULT })}
        name="description"
      />
    </div>
  );
}
